// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3FG4x","signatureButtonsRight":"ModalSign_signatureButtonsRight__2y2cR"};